//* Original locale definitions
// export default {
//   en: 'English',
//   ja: '日本人 (Japanese)',
//   ko: '한국어 (Korean)',
//   cs: 'čeština (Czech)',
//   fr: 'Français (French)',
//   // zhCN: '(Simplified Chinese)',
//   // zhTW: '(Traditional Chinese)',
//   vi: 'Tiếng Việt (Vietnamese)',
//   pt: 'Português (Portugese)',
//   es: 'Español (Spanish)',
//   ar: 'عربي (Arabic)',
//   it: 'Italiano (Italian)',
//   de: 'Deutsche (German)',
//   hi: 'हिंदी (Hindi)',
//   ru: 'русский (Russian)',
// };

import enFlag from '@/assets/flags/flag_en.svg';
import jaFlag from '@/assets/flags/flag_ja.svg';
import koFlag from '@/assets/flags/flag_ko.svg';
import csFlag from '@/assets/flags/flag_cs.svg';
import frFlag from '@/assets/flags/flag_fr.svg';
import viFlag from '@/assets/flags/flag_vi.svg';
import ptFlag from '@/assets/flags/flag_pt.svg';
import esFlag from '@/assets/flags/flag_es.svg';
import arFlag from '@/assets/flags/flag_ar.svg';
import itFlag from '@/assets/flags/flag_it.svg';
import deFlag from '@/assets/flags/flag_de.svg';
import hiFlag from '@/assets/flags/flag_hi.svg';
import ruFlag from '@/assets/flags/flag_ru.svg';

export default {
  en: {
    shortName: 'en',
    longName: 'English',
    localName: 'English',
    customName: 'English',
    // flag: '/flag_en.svg',
    flag: enFlag,
  },
  ja: {
    // '日本人 (Japanese)'
    shortName: 'ja',
    longName: 'Japanese',
    localName: '日本語',
    customName: '日本人 (Japanese)',
    // flag: '/flag_ja.svg',
    flag: jaFlag,
  },
  ko: {
    // '한국어 (Korean)'
    shortName: 'ko',
    longName: 'Korean',
    localName: '한국어',
    customName: '국어 (Korean)',
    // flag: '/flag_ko.svg',
    flag: koFlag,
  },
  cs: {
    // 'čeština (Czech)'
    shortName: 'cs',
    longName: 'Czech',
    localName: 'čeština',
    customName: 'ina (Czech)',
    // flag: '/flag_cs.svg',
    flag: csFlag,
  },
  fr: {
    // 'Français (French)'
    shortName: 'fr',
    longName: 'French',
    localName: 'Français',
    customName: 'Français (French)',
    // flag: '/flag_fr.svg',
    flag: frFlag,
  },
  // // zhCN: '(Simplified Chinese)',
  // // zhTW: '(Traditional Chinese)',
  vi: {
    // vi: 'Tiếng Việt (Vietnamese)',
    shortName: 'vi',
    longName: 'Vietnamese',
    localName: 'Tiếng Việt',
    customName: 'Tiếng Việt (Vietnamese)',
    // flag: '/flag_vi.svg',
    flag: viFlag,
  },
  pt: {
    // pt: 'Português (Portugese)',
    shortName: 'pt',
    longName: 'Portugese',
    localName: 'Português',
    customName: 'Português (Portugese)',
    // flag: '/flag_pt.svg',
    flag: ptFlag,
  },
  es: {
    // es: 'Español (Spanish)',
    shortName: 'es',
    longName: 'Spanish',
    localName: 'Español',
    customName: 'Español (Spanish)',
    // flag: '/flag_es.svg',
    flag: esFlag,
  },
  ar: {
    // ar: 'عربي (Arabic)',
    shortName: 'ar',
    longName: 'Arabic',
    localName: 'عربي',
    customName: 'عربي (Arabic)',
    // flag: '/flag_ar.svg',
    flag: arFlag,
  },
  it: {
    // it: 'Italiano (Italian)',
    shortName: 'it',
    longName: 'Italian',
    localName: 'Italiano',
    customName: 'Italiano (Italian)',
    // flag: '/flag_it.svg',
    flag: itFlag,
  },
  de: {
    // de: 'Deutsche (German)',
    shortName: 'de',
    longName: 'German',
    localName: 'Deutsche',
    customName: 'Deutsche (German)',
    // flag: '/flag_de.svg',
    flag: deFlag,
  },
  hi: {
    // hi: 'हिंदी (Hindi)',
    shortName: 'hi',
    longName: 'Hindi',
    localName: 'हिंदी',
    customName: 'हिंदी (Hindi)',
    // flag: '/flag_hi.svg',
    flag: hiFlag,
  },
  ru: {
    // ru: 'русский (Russian)',
    shortName: 'ru',
    longName: 'Russian',
    localName: 'русский',
    customName: 'русский (Russian)',
    // flag: '/flag_ru.svg',
    flag: ruFlag,
  },
};
